import Reveal from '@/components/base/Reveal';

const principles = [
  { number: '01', title: 'People First', description: 'Great hospitality starts with people who care.' },
  { number: '02', title: 'Quality Matters', description: 'From the product to the guest experience, details matter.' },
  { number: '03', title: 'Community', description: 'Restaurants should feel connected to the neighborhoods they serve.' },
  { number: '04', title: 'Long-Term Thinking', description: 'We focus on building concepts and teams with staying power.' },
];

export default function Approach() {
  return (
    <section className="py-24 md:py-32 px-6 md:px-10 bg-background-100">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
        <Reveal>
          <div className="lg:sticky lg:top-28">
            <p className="text-xs uppercase tracking-[0.35em] text-primary-600">Our Approach</p>
            <h2 className="font-heading text-3xl md:text-5xl mt-6 text-foreground-950 leading-[1.1]">
              Built around people. Driven by hospitality.
            </h2>
            <div className="mt-10 w-full h-64 md:h-80 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20editorial%20photograph%20of%20restaurant%20staff%20and%20guests%20interacting%20warmly%20at%20a%20host%20stand%20in%20a%20modern%20American%20restaurant%2C%20genuine%20smiles%2C%20natural%20hospitality%20moment%2C%20soft%20warm%20lighting%2C%20wooden%20and%20earth%20tones%2C%20authentic%20and%20human%2C%20high-end%20hospitality%20brand%20photography&width=1400&height=1000&seq=jedl-approach-1&orientation=landscape"
                alt="Restaurant staff warmly greeting guests at a host stand"
                title="JEDL Restaurants — hospitality approach"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </Reveal>

        <div className="flex flex-col">
          {principles.map((p, i) => (
            <Reveal key={p.number} delay={i * 80}>
              <div className="border-b border-background-200 py-7">
                <span className="text-xs tracking-[0.25em] text-foreground-400">{p.number}</span>
                <h3 className="font-heading text-2xl md:text-3xl mt-3 text-foreground-950 uppercase tracking-wide">
                  {p.title}
                </h3>
                <p className="mt-3 text-foreground-600 leading-relaxed">{p.description}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}